var $42d5bcc619a7aaac$exports = {};
$42d5bcc619a7aaac$exports = {
    "collectionLabel": `Sugestii`
};


export {$42d5bcc619a7aaac$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
